import { Box, MenuItem, Paper } from "@material-ui/core";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ReplyIcon from '@mui/icons-material/Reply';
import { Autocomplete, Button, TextField } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import 'dayjs/locale/en-gb';
import { asBlob, generateCsv, mkConfig } from 'export-to-csv'; //or use your library of choice here
import {
  MaterialReactTable,
  createMRTColumnHelper,
  useMaterialReactTable,
} from 'material-react-table';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Swal from "sweetalert2";
import LoaderBar from "../../components/LoaderBar/LoaderBar";
import PageTitle from "../../components/PageTitle/PageTitle";
import axios from '../../utils/axios';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#A7C7E7",
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));


const SettledDividend = () => {

  const [data,setData] = useState([]);
  const [dividendType,setDividendType] = useState([]);
  const [branchList,setBranchList] = useState([]);
  const [issuerList,setIssuerList] = useState([]);
  const [isLoading,setIsLoading] = useState(false);
  const [selectedIssuer,setSelectedIssuer] = useState("");
  const [selectedToDate, setSelectedToDate] = useState(null);
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedDividendType,setSelectedDividendType] = useState("Cash");
  let accounts = [{id:1,label:"Joint Account"},{id:2,label:"Individual Account"}] ;
  
let claimtypelist =[{id:1,label:"Self"},{id:2,label:"Authorized Person/Power of Attorney"},{id:3,label:"Successor/Nominee"}] 
  const { register, control,setValue } = useForm({});
  const handleShowData = async () => {
    // fetchData();
    // console.log(selectedIssuer,selectedToDate,selectedFromDate,selectedDividendType)
    const submitJson = {issuerId:selectedIssuer,dividendType:selectedDividendType,fromDate:selectedFromDate,toDate:selectedToDate}
    getSettledDividendList(submitJson);
  }

    
    const getSettledDividendList = async (submitJson) =>{
      setIsLoading(true);
      try
      {
        const response = await axios.post('/settlement/get-by-settlement-date',submitJson)
        let res = response.data.payload;
        let modifiedData =[]
        res.map((item,index) =>{
          const rowWithFetchedId = dividendType.find(row => row.id === item.investor_dividend_type_id);
          const labelToShow = rowWithFetchedId ? rowWithFetchedId.investorDividendType+ "("+rowWithFetchedId.dividendType+")"  : item.investor_dividend_type_id;
          const accountTypeidfound = accounts.find(row=>row.id===item.account_type);
          const accountTypeLabel = accountTypeidfound ? accountTypeidfound.label : item.account_type;
          const YearList = item.years.join(", ");
          const applicationdateformat = new Date(item.application_date).toISOString().split("T")[0];
          const recievedateformat = new Date(item.receive_date).toISOString().split("T")[0];
          const entrydateformat = new Date(item.createdat).toISOString().split("T")[0];
          const uploaddateformat = item.uploadedat ? new Date(item.uploadedat).toISOString().split("T")[0] : null;
          const updatedateformat = new Date(item.updatedat).toISOString().split("T")[0];
          const claimTypeText = claimtypelist.find(row=>row.id===item.claimtype)?.label ;
          delete item.years;
          modifiedData.push({...item,investorDividendType:labelToShow,accountTypeLabel:accountTypeLabel,yearList:YearList,index:index+1,claimTypeText:claimTypeText,application_date:applicationdateformat,receive_date:recievedateformat,createdat:entrydateformat,updatedat:updatedateformat,uploadedat:uploaddateformat})

        })
        setData(modifiedData);
        setIsLoading(false);
      }
      catch(error)
      {
        setIsLoading(false);
        console.error('Error fetching ready to settled list:', error.response?.data?.message || error.message);
      }
      
    }



  useEffect(() => {
    
    try {

       axios.get('./issuer/get-info')
      .then((res)=>{
        setIssuerList([{ id: 'All', name: 'All',tradecode:'All'},...res?.data?.payload]);
        // setSelectedIssuer('All');
      })
      .catch((err) =>{
        console.log(err)
      })
      // Fetch dividend types
       axios.get('/inward-dividend/get-dividend-types')
       .then((response)=>{
        let res = response.data.payload;
        console.log(res);
        setDividendType(response.data.payload);
       })
       .catch((e)=>{
        console.error(e);
       })
       
        
    } catch (error) {
      console.error('Error fetching data:', error);
    
  }
  // setSelectedIssuer('All');
  setSelectedDividendType('Cash');
  setSelectedFromDate("All");
  setSelectedToDate("All");
  
  
  }, [])


  
  const columnHelper = createMRTColumnHelper();

  const columns = [
    
    columnHelper.accessor('index', {
      header: 'SL',
      size: 40,
    }),
    columnHelper.accessor('settlementno', {
      header: 'Settlement No',
      size: 40,
    }),
    columnHelper.accessor('name', {
      header: 'Investor Name',
    }),
    columnHelper.accessor('issuer_name', {
      header: 'Issuer Name',
      size: 120,
    }),
    columnHelper.accessor('investorDividendType', {
      header: 'Investor Dividend Type',
      size: 220,
    }),
    columnHelper.accessor('claimTypeText', {
      header: 'Claim Type',
      size: 220,
    }),
    columnHelper.accessor('claimantname', {
      header: 'Claimant Name',
      size: 220,
    }),
    columnHelper.accessor('claimantnid', {
      header: 'Claimant NID',
      size: 220,
    }),
    columnHelper.accessor('settlementdate', {
      header: 'CMSF\'s settlement date',
      size: 220,
    }),
    columnHelper.accessor('bo_id', {
      header: 'BOID',
      size: 120,
    }),
    columnHelper.accessor('folio_number', {
      header: 'FOLIO NO',
  
    }),
    columnHelper.accessor('nid', {
      header: 'NID',
  
    }),
    columnHelper.accessor('passport', {
      header: 'Passport No',
  
    }),
    
    columnHelper.accessor('bankname', {
      header: 'Bank Name',
      size: 220,
    }),
    columnHelper.accessor('branchname', {
      header: 'Branch',
      size: 220,
    }),
    columnHelper.accessor('bankaccountno', {
      header: 'Account No',
      size: 220,
    }),
    columnHelper.accessor('routingno', {
      header: 'Routing No',
      size: 220,
    }),
    columnHelper.accessor('dpname', {
      header: 'DP House',
      size: 220,
    }),
    columnHelper.accessor('dpid', {
      header: 'DP House ID',
      size: 220,
    }),
    columnHelper.accessor('stockunitprice', {
      header: 'Stock Unit Price',
      size: 220,
    }),
    columnHelper.accessor('yearList', {
      header: 'Year',
      size: 220,
    }),
    columnHelper.accessor('total_amount', {
      header: 'Cash / Stock',
      Cell: ({ row }) => {
        const [openPreview, setOpenPreview] = useState(false);
        const [YearDetailsList, setYearDetailsList] = useState([]);
        const style = {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '60%',
          bgcolor: 'background.paper',
          border: '2px solid #eee',
          boxShadow: '2px 2px 2px 2px #eee',
          borderRadius:"10px",
          p: 4
        };
  
  
        const handlePreviewClick = async () => {
          const response = await axios.get(`settlement/get-by-settlement-details/${row.original.settlement_id}`);
          let res = response.data.payload;
          console.log(res);
          setYearDetailsList(res);
          // setYearDetailsList([{year:"2010",amount:"507",yearterm:"Third Dividend Year (FYI)"},{year:"2011",amount:"850",yearterm:"Final Dividend Year (FYI)"}
          //   ,{year:"2009",amount:"1150",yearterm:"Second Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
          //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
          //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
          //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
          //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
          //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
          //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
          //   ,{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"},{year:"2012",amount:"1520",yearterm:"First Dividend Year (FYI)"}
          // ])
          setOpenPreview(true);
        };
        const openModal = () =>{
          return(
          <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openPreview}
          onClose={() => setOpenPreview(false)}
          closeAfterTransition
          BackdropComponent={Backdrop}
          slots={{ backdrop: Backdrop }}
          slotProps={{
          backdrop: {
              timeout: 500,
          }}}
         style={{overflow: "auto", display:"flex",justifyContent:"center",alignItems:"center", textAlign:"center", borderRadius:"10px"
         }}
         >
          <Fade in={openPreview}>
          <Box sx={style} style={{textAlign:"center",width:"80%",height:"80vh"}} >
              <h3>Year wise settled dividend amount details </h3>
              <Paper style={{ margin:"10px 50px 10px 50px",padding:"10px",boxShadow:"2px 2px 2px 2px gray",justifyContent:"center"}} container spacing={2} >
              <TableContainer component={Paper} sx={{ width: '100%',maxHeight: 440}}>
            <Table sx={{ minWidth: 700 }} stickyHeader aria-label="simple table">
              <TableHead style={{fontSize:"1.2rem"}}>
                <TableRow>
                  <StyledTableCell align="center"  style={{fontSize:"1.2rem"}}>Year</StyledTableCell>
                  <StyledTableCell align="center"  style={{fontSize:"1.2rem"}}>Interim</StyledTableCell>
                  <StyledTableCell align="center"  style={{fontSize:"1.2rem"}}>Cash / Stock</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{overflow:"hidden",maxHeight:440}}>
                {YearDetailsList.map((row,id) => (
                  <StyledTableRow key={id}>
                    <StyledTableCell align="center">{row.year}</StyledTableCell>
                    <StyledTableCell align="center">{row.yearterm}</StyledTableCell>
                    <StyledTableCell align="center">{row.amount}</StyledTableCell>

                  </StyledTableRow>
                ))}
                <StyledTableRow  sx={{
                                position: "sticky",
                                bottom: 0,
                               backgroundColor: "#A7C7E7 !important",
                                zIndex: 2, // Ensures it stays above the content
                              }}>
                <StyledTableCell align="center" style={{fontSize:"1.2rem"}} colSpan={1}><strong>Total</strong></StyledTableCell>
                <StyledTableCell align="center" ></StyledTableCell>
                <StyledTableCell align="center"  style={{fontSize:"1.2rem"}}><strong>{row.original.total_amount}</strong></StyledTableCell>

                  </StyledTableRow>
              </TableBody>
              
            </Table>
          </TableContainer>
          </Paper>
          <Button type="button" onClick={()=>setOpenPreview(false)} variant="contained" color="info" style={{color:"white"}}><ReplyIcon/> Go Back</Button>
          </Box>
          </Fade>
      </Modal>
          )}
  
        return (
          <>
            <Button variant="contained" color="primary" onClick={handlePreviewClick}>
              {row.original.total_amount}
            </Button>
            {
              openPreview && openModal()
            }
          </>
        );
      },
      size: 220,
    }),
    columnHelper.accessor('accountTypeLabel', {
      header: 'Account Type',
      size: 220,
    }),
    columnHelper.accessor('shareholder_name', {
      header: 'Second Investor\'s Name',
      size: 220,
    }),
    columnHelper.accessor('sholdernid', {
      header: 'Second Investor\'s NID',
      size: 220,
    }),
    columnHelper.accessor('sholderpassport', {
      header: 'Second Investor\'s Passport',
      size: 220,
    }),
    
    columnHelper.accessor('application_date', {
      header: 'Application Date',
      size: 220,
    }),
    columnHelper.accessor('receive_date', {
      header: 'Claim Recieve Date',
      size: 220,
    }),
    columnHelper.accessor('remarks', {
      header: 'Remarks',
      size: 220,
    }),
    
    
    columnHelper.accessor('createdby', {
      header: 'Entry By',
      size: 220,
    }),
    columnHelper.accessor('createdat', {
      header: 'Entry Date',
      size: 220,
    }),
    columnHelper.accessor('updatedby', {
      header: 'Settlement Update By',
      size: 220,
    }),
    columnHelper.accessor('updatedat', {
      header: 'Settled Update Date',
      size: 220,
    }),
    columnHelper.accessor('uploadedby', {
      header: 'File Uploaded By',
      size: 220,
    }),
    columnHelper.accessor('uploadedat', {
      header: 'File Uploaded Date',
      size: 220,
      
    }),
    columnHelper.accessor('folio_bo_file', {
      header: 'Settlement PDF',
      size: 220,
      Cell: ({ row }) => {
      // Local state to handle preview dialog visibility
      const [openPreview, setOpenPreview] = useState(false);
      const [filePreview, setFilePreview] = useState('');
      
      const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        bgcolor: 'background.paper',
        border: '2px solid #eee',
        boxShadow: '2px 2px 2px 2px #eee',
        borderRadius:"10px",
        p: 4
      };


      const handlePreviewClick = async () => {
        try{
        const fileUrlfromDB = row.original.folio_bo_file;  // Access the file URL from the row
        const fileURLclean = fileUrlfromDB.replace(/^\["|"\]$/g, '');
        const response = await axios.post(`/settlement/get-settlement-file/${row.original.settlement_id}`,{ filename: fileURLclean },
          { responseType: 'blob' });
          const file = new Blob([response.data], { type: 'application/pdf' });
          const fileUrl = URL.createObjectURL(file);

        
        if (fileUrl) {
          setFilePreview(fileUrl); // Set the file preview URL
          }
          setOpenPreview(true); 
        }
        catch (error) {
          console.error("Error fetching PDF:", error);
      
          // Check if the error is a 404 Not Found
          if (error.response && error.response.status === 404) {
            Swal.fire({
              icon: "warning",
              title: "File Not Found",
              text: "The requested PDF file was not uploaded on the server.",
            });
          } else {
            // Handle other errors
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong while fetching the file!",
            });
          }
        }
      };
      const openModal = () =>{
        return(
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        slots={{ backdrop: Backdrop }}
        slotProps={{
        backdrop: {
            timeout: 500,
        }}}
       style={{overflow: "auto", display:"flex",justifyContent:"center",alignItems:"center", textAlign:"center", borderRadius:"10px"
       }}
       >
        <Fade in={openPreview}>
        <Box sx={style} style={{textAlign:"center",width:"80%",height:"80vh"}} >
            <h3>PDF VIEWER </h3>
            
            
            
            <Box className="form-control" style={{textAlign:"center",height:"90%"}}>
              
            {
            // filePreview ? 
            
            filePreview ? (
              <embed src={filePreview} width="100%" height="93%" type="application/pdf" />
            ) 
            :
            (
              <div
                  style={{
                      alignItems: 'center',
                      border: '2px dashed rgba(0, 0, 0, .3)',
                      fontSize: '2rem',
                      height: '100%',
                      display:"flex",
                      justifyContent: 'center',
                      width: '100%',
                      marginBottom:"5px"
                  }}
              >
                  View Area<br/>
                  Oops! The file is not uploaded yet.
              </div>
          )
          }
                
                
                <Button type="button" onClick={()=>{setOpenPreview(false);}} variant="contained" color="info" style={{color:"white"}}><ReplyIcon/> Close</Button>
                </Box>

                
             
        </Box>
        </Fade>
    </Modal>
        )}

      return (
        <>
          <Button variant="contained" color="primary" onClick={handlePreviewClick}>
            View File
          </Button>
          {
            openPreview && openModal()
          }
        </>
      );
    },
    }),
  ];
  
  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
  });








  const handleExportRows = (rows) => {
    const csv = generateCsv(csvConfig)(rows);
    const blob = asBlob(csvConfig)(csv);
    const fileURL = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = fileURL;
    link.setAttribute("download", `Settled Dividend Rows.csv`);
    link.click();
    // download(csvConfig)(csv);
  };

  const handleExportData = () => {
    const csv = generateCsv(csvConfig)(data);
    const blob = asBlob(csvConfig)(csv);
    const fileURL = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = fileURL;
    link.setAttribute("download", `All Settled Dividend.csv`);
    link.click();
    // download(csvConfig)(csv);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    // enableRowSelection: true,
    initialState: { density: 'compact' },
    columnFilterDisplayMode: 'popover',
    paginationDisplayMode: 'pages',
    enableStickyHeader: true,
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 15, 20, 25, 30, 50, 100, data.length]
    },
    // enableBottomToolbar: false,
    // positionToolbarAlertBanner: 'bottom',
    muiTableContainerProps: {

      style: { maxHeight: '50vh' } 

  },
    renderBottomToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          padding: '8px',
          flexWrap: 'wrap',
        }}
      >
       
        <Button
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          variant="contained"
          onClick={handleExportData}
          startIcon={<FileDownloadIcon />}
          disabled={table.getPrePaginationRowModel().rows.length === 0}
        >
          Export All Data
        </Button>
        {
          selectedDividendType === "Cash"
          ?
          <Button variant="contained">
            Total Settled Cash : {Number(data.reduce((total, row) => {const amt = parseFloat(row.total_amount);
                  return total + (isNaN(amt) ? 0 : amt);}, 0)).toFixed(2)} BDT
        </Button>
        : 
        selectedDividendType === "Stock"
        ?
        <Button variant="contained" >
            Total Settled Stock : {Number(data.reduce((total, row) => {const amt = parseFloat(row.total_amount);
                  return total + (isNaN(amt) ? 0 : amt);}, 0)).toFixed(2)}
        </Button>
        :
        null
        }
        {/* <Button
          disabled={table.getPrePaginationRowModel().rows.length === 0}
          //export all rows, including from the next page, (still respects filtering and sorting)
          onClick={() =>
            handleExportRows(data)
          }
          startIcon={<FileDownloadIcon />}
        >
          Export All Rows
        </Button>
        <Button
          disabled={table.getRowModel().rows.length === 0}
          //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
          onClick={() => handleExportRows(table.getRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          Export Page Rows
        </Button>
        <Button
          disabled={
            !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
          }
          //only export selected rows
          onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          Export Selected Rows
        </Button> */}
      </Box>
    ),
  });

  return( <>
          <PageTitle title={"Compliance Report"}></PageTitle>
          <Box style={{display:"flex",marginBottom:"20px"}}>
       
          <Controller
        name="issuerId"
        control={control}
        
        render={({ field }) => (
          <Autocomplete
            {...field}
            options={issuerList}
            style={{width:"20%"}}
            getOptionLabel={(option) => `${option.name} (${option.tradecode})`}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Issuer"
                variant="outlined"
                fullWidth
                required
              />
            )}
            onChange={(_, data) =>{ 
              if(data)
              {
                field.onChange(data.id);
                setSelectedIssuer(data.id);
              }
              else{
                field.onChange(null);
                setSelectedIssuer(null);
              }
            }} // Update the form value
          />
        )}
      />
      <TextField 
                    select
                    name="dividendType"
                    // {...register("p_settlementstatus", { required: true })}
                    label="Select Dividend Type"
                    variant="outlined"
                    className="input-field"
                    fullWidth
                    onChange={(e)=>{setSelectedDividendType(e.target.value)}}
                    style={{ marginLeft: "5px",width:"20%" }}
                    value={selectedDividendType}
                  >
                      <MenuItem value="Cash"
                      style={{ fontSize: 13,fontWeight:"bold" }}
                      >
                        Cash
                      </MenuItem>
                      <MenuItem value="Stock"
                      style={{ fontSize: 13,fontWeight:"bold" }}
                      >
                        Stock
                      </MenuItem>
              </TextField> 
            <Controller
              name="fromDate"
              control={control}
              render={({ field: { onChange, value } })  => (
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
                  <DatePicker sx={{marginLeft:"5px",width:"20%"}}
                  label="From Date"
                    onChange={(date) => {
                      date = date ? date.format("YYYY/MM/DD") : ""
                    setSelectedFromDate(date);
                  }
                      }
                    renderInput={(params) => (
                      <TextField 
                        fullWidth
                        {...params}
                        label="Settlement Date"
                        variant="outlined"
                      />
                    )}
                  />
                </LocalizationProvider>
              )}
            />
            <Controller
              name="toDate"
              control={control}
              render={({ field: { onChange, value } })  => (
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
                  <DatePicker sx={{marginLeft:"5px",width:"20%"}}
                  label="To Date"
                    onChange={(date) => {
                      date = date ? date.format("YYYY/MM/DD") : ""
                    setSelectedToDate(date);
                  }
                      }
                    renderInput={(params) => (
                      <TextField 
                        fullWidth
                        {...params}
                        label="Settlement Date"
                        variant="outlined"
                      />
                    )}
                  />
                </LocalizationProvider>
              )}
            />

               
            <Button style={{marginLeft:"20px"}} variant="contained" disabled = {selectedIssuer=="" || selectedDividendType=="" ? true : false} color="primary" onClick={handleShowData}>Search</Button>
          </Box>
          {
            isLoading 
            ?
            <LoaderBar/>
            :
            <MaterialReactTable table={table} enableStickyFooter/>
            
          }
        </>);
};

export default SettledDividend;
